/** Port von `IwmSharedColumnsCheckbox.razor` — nur Anzeige, nie bedienbar. */

import { CheckBox } from '@/components/ui';

export interface CheckboxCellProps {
  value: boolean | null | undefined;
}

export function CheckboxCell(props: CheckboxCellProps) {
  if (props.value === null || props.value === undefined) return null;
  return <CheckBox checked={props.value} disabled />;
}

export default CheckboxCell;
